import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CapsLockStateService {

  private capsLockOnSubject = new BehaviorSubject<boolean>(false);
  capsLockOn$ = this.capsLockOnSubject.asObservable();

  constructor() {
    window.addEventListener('keydown', (event: KeyboardEvent) => this.updateState(event));
    window.addEventListener('keyup', (event: KeyboardEvent) => this.updateState(event));
  }

  private updateState(event: KeyboardEvent): void {
    this.capsLockOnSubject.next(event.getModifierState('CapsLock'));
  }
}
